import { ReactNode, useState } from "react";
import { TenantWithPeopleInfo } from "../../../api/api-hooks/cloud/useCloud";
import AppTooltip from "../../../elements/AppTooltip";

interface Props {
  cloud?: TenantWithPeopleInfo;
}

const DetailSection = ({
  title,
  text,
}: {
  title: string;
  text: ReactNode | undefined;
}) => {
  return (
    <div className="d-flex items-center">
      <h5 className="mb-0">{title}</h5>
      <div className="h5 font-weight-normal ml-2">{text}</div>
    </div>
  );
};

function CopyableText({ text }: { text: string | undefined }) {
  const [copied, setCopied] = useState(false);

  return (
    <AppTooltip
      useTooltip
      content={copied ? "Copied to clipboard" : "Click to copy"}
      placement="bottomStart"
    >
      <pre
        className="mb-0 cursor-pointer"
        onClick={() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
          navigator.clipboard.writeText(text || "");
        }}
      >
        <small className="mb-0">{text}</small>
      </pre>
    </AppTooltip>
  );
}

const CloudDetails = ({ cloud }: Props) => {
  return (
    <div className="tw:mt-5 tw:flex tw:flex-col tw:md:flex-row  tw:items-start">
      <div className="tw:w-1/2 tw:flex tw:flex-col">
        <div className="tw:mb-5">
          <h3 className="mb-0">Primary Address:</h3>
          <CopyableText text={cloud?.BillingAddress} />
        </div>
        <div className="tw:mb-5">
          <h3 className="mb-0">Cloud UUID:</h3>
          <CopyableText text={cloud?.id} />
        </div>
        <div className="tw:mb-5">
          <h3 className="mt-3 mb-0">Cloud Tier</h3>
          <CopyableText text={cloud?.Tier} />
        </div>
        <div className="tw:mb-5">
          <h3 className="mt-3 mb-0">Cloud Prefix</h3>
          <CopyableText text={cloud?.Code} />
        </div>
      </div>
      <div className="tw:w-1/2 tw:flex tw:flex-col">
        <div className="tw:mb-5">
          <h3 className="mb-0">Contact Methods:</h3>
          <DetailSection
            title="Web:"
            text={
              cloud?.CompanyWebsite ? (
                <a href={cloud?.CompanyWebsite} target="_blank">
                  {cloud?.CompanyWebsite}
                </a>
              ) : (
                "--"
              )
            }
          />
          <DetailSection title="Name:" text={cloud?.BillingContactName} />
          <DetailSection title="Email:" text={cloud?.BillingContactEmail} />
          <DetailSection
            title="Phone:"
            text={
              cloud?.Phone ? (
                <a href={"tel:" + cloud?.Phone} target="_blank">
                  {cloud?.Phone}
                </a>
              ) : (
                "--"
              )
            }
          />
        </div>
        <div className="tw:mb-5">
          <h3 className="mb-0">Cloud Database:</h3>
          <CopyableText text={cloud?.DatabaseName} />
        </div>
        <div className="tw:mb-5">
          <h3 className="mt-3 mb-0">Azure Storage Container:</h3>
          <CopyableText text={cloud?.StorageContainerName} />
        </div>
      </div>
    </div>
  );
};

export default CloudDetails;
